import { useEffect, useState } from "react";
import { StatusBadge } from "@/components/StatusBadge";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

function formatDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleDateString("ms-MY", { day: "2-digit", month: "long", year: "numeric" });
}

export default function StatusKeahlian() {
  const [member, setMember] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/members/me"),
      api.get("/members/me/profile").catch(() => ({ data: null })),
    ])
      .then(([m, p]) => { setMember(m.data); setProfile(p.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-center text-piks-muted">Memuatkan...</div>;
  if (!member) return <div className="p-8 text-center text-piks-muted" data-testid="status-empty-state">Tiada rekod keahlian.</div>;

  return (
    <div className="p-6 sm:p-10 max-w-2xl" data-testid="status-keahlian-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-6">Status Keahlian</h1>
      <div className="p-6 rounded-xl bg-white border border-piks-border mb-8">
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm text-piks-muted">Status Semasa</span>
          <StatusBadge status={member.status} />
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div><p className="text-piks-muted text-xs">No. Ahli</p><p className="font-mono font-semibold text-piks-black">{member.member_number}</p></div>
          <div><p className="text-piks-muted text-xs">Kategori</p><p className="font-semibold text-piks-black">{member.category_name}</p></div>
          <div><p className="text-piks-muted text-xs">Ahli Sejak</p><p className="font-semibold text-piks-black">{formatDate(member.member_since)}</p></div>
          <div><p className="text-piks-muted text-xs">Sah Sehingga</p><p className="font-semibold text-piks-black">{formatDate(member.valid_until)}</p></div>
        </div>
      </div>

      {profile?.course_name && (
        <div className="p-6 rounded-xl bg-white border border-piks-border mb-8" data-testid="status-course-info">
          <h2 className="text-sm font-semibold text-piks-muted uppercase tracking-wide mb-4">Maklumat Kursus</h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div><p className="text-piks-muted text-xs">Nama Kursus</p><p className="font-semibold text-piks-black">{profile.course_name}</p></div>
            <div><p className="text-piks-muted text-xs">Tarikh Kursus</p><p className="font-semibold text-piks-black">{formatDate(profile.course_date)}</p></div>
            <div><p className="text-piks-muted text-xs">Sesi / Tahun</p><p className="font-semibold text-piks-black">{profile.course_session_year}</p></div>
            <div><p className="text-piks-muted text-xs">Tempat Kursus</p><p className="font-semibold text-piks-black">{profile.course_venue}</p></div>
          </div>
        </div>
      )}

      <h2 className="text-sm font-semibold text-piks-muted uppercase tracking-wide mb-4">Sejarah Status</h2>
      <div className="space-y-3">
        {(member.status_history || []).map((h, i) => (
          <div key={i} className="flex items-start gap-3 p-4 rounded-lg bg-white border border-piks-border" data-testid={`status-history-${i}`}>
            <Clock className="w-4 h-4 text-piks-muted mt-0.5" />
            <div>
              <p className="text-sm font-medium text-piks-black">{h.previous_status ? `${h.previous_status} → ${h.new_status}` : `Ditetapkan sebagai ${h.new_status}`}</p>
              <p className="text-xs text-piks-muted mt-0.5">{formatDate(h.changed_at)} {h.reason && `— ${h.reason}`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
